import { cloneDeep, isNumber } from "lodash";
import { ProductBatchItemFromFileUpdateStockPercentualModel } from "./ProductBatchItemFromFileUpdateStockPercentualModel";

interface ColumnInfo {
	pos: number;
	description: string;
}

export class ProductBatchItemFromFileUpdateStockPercentualFormModel {
	skuCode: ColumnInfo | null = null;
	codeSource: ColumnInfo | null = null;
	percentual: ColumnInfo | null = null;
	columnList: ColumnInfo[] = [];
	itemList: ProductBatchItemFromFileUpdateStockPercentualModel[] = [];
	private _rawData: any[][] = [];

	initializeData(arrayFromFile: any[][]): void {
		this._rawData = cloneDeep(arrayFromFile);
		this.columnList = (this._rawData[0] || []).map((col, index) => {
			return {
				pos: index,
				description: col,
			}
		})

		this.columnList.forEach((col) => {
			const containsSkuInfo = col.description.toLowerCase().indexOf('sku') > -1;

			const containsCodeSourceInfo = (col.description.toLowerCase().indexOf('codigo') > -1) ||
				(col.description.toLowerCase().indexOf('código') > -1);

			const containsPercentualInfo = (col.description.toLowerCase().indexOf('percentual') > -1) ||
				(col.description.toLowerCase().indexOf('percentual') > -1);


			if (containsSkuInfo) {
				this.skuCode = col
			}

			if (containsCodeSourceInfo) {
				this.codeSource = col
			}

			if (containsPercentualInfo) {
				this.percentual = col
			}
		})

		const items = cloneDeep(this._rawData).slice(1);
		const skuCodePos = this.skuCode?.pos == undefined ? null : this.skuCode?.pos
		const codeSourcePos = this.codeSource?.pos == undefined ? null : this.codeSource.pos
		const percentualPos = this.percentual?.pos == undefined ? null : this.percentual.pos

		for (const item of items) {
			this.itemList.push(new ProductBatchItemFromFileUpdateStockPercentualModel({
				skuCode: isNumber(skuCodePos) ? item[skuCodePos] : null,
				codeSource: isNumber(codeSourcePos) ? item[codeSourcePos] : null,
				stockPercentage: isNumber(percentualPos) ? item[percentualPos] : null,
			}))
		}
	}

	updateItemListSkuInfo(skuColInfo: ColumnInfo): void {
		const items = cloneDeep(this._rawData).slice(1);
		const codeSourcePos = this.codeSource?.pos == undefined ? null : this.codeSource.pos
		const percentualPos = this.percentual?.pos == undefined ? null : this.percentual.pos

		this.itemList = items.map((list) => {
			return new ProductBatchItemFromFileUpdateStockPercentualModel({
				skuCode: skuColInfo ? list[skuColInfo.pos] : null,
				codeSource: isNumber(codeSourcePos) ? list[codeSourcePos] : null,
				stockPercentage: isNumber(percentualPos) ? list[percentualPos] : null,
			})
		})
	}

	updateItemListCodeSourceInfo(codeSourceColInfo: ColumnInfo): void {
		const items = cloneDeep(this._rawData).slice(1);
		const skuCodePos = this.skuCode?.pos == undefined ? null : this.skuCode?.pos
		const percentualPos = this.percentual?.pos == undefined ? null : this.percentual.pos

		this.itemList = items.map((list) => {
			return new ProductBatchItemFromFileUpdateStockPercentualModel({
				skuCode: isNumber(skuCodePos) ? list[skuCodePos] : null,
				codeSource: codeSourceColInfo ? list[codeSourceColInfo.pos] : null,
				stockPercentage: isNumber(percentualPos) ? list[percentualPos] : null,
			})
		})
	}

	updateItemPercentualInfo(percentualInfo: ColumnInfo): void {
		const items = cloneDeep(this._rawData).slice(1);
		const skuCodePos = this.skuCode?.pos == undefined ? null : this.skuCode?.pos
		const codeSourcePos = this.codeSource?.pos == undefined ? null : this.codeSource.pos

		this.itemList = items.map((list) => {
			return new ProductBatchItemFromFileUpdateStockPercentualModel({
				skuCode: isNumber(skuCodePos) ? list[skuCodePos] : null,
				codeSource: isNumber(codeSourcePos) ? list[codeSourcePos] : null,
				stockPercentage: percentualInfo ? list[percentualInfo.pos] : null,
			})
		})
	}

	updateItemListSellPriceInfo(sellPriceColInfo: ColumnInfo): void {
		const items = cloneDeep(this._rawData).slice(1);
		const skuCodePos = this.skuCode?.pos == undefined ? null : this.skuCode?.pos
		const codeSourcePos = this.codeSource?.pos == undefined ? null : this.codeSource.pos
		const percentualPos = this.percentual?.pos == undefined ? null : this.percentual.pos

		this.itemList = items.map((list) => {
			return new ProductBatchItemFromFileUpdateStockPercentualModel({
				skuCode: isNumber(skuCodePos) ? list[skuCodePos] : null,
				codeSource: isNumber(codeSourcePos) ? list[codeSourcePos] : null,
				stockPercentage: isNumber(percentualPos) ? list[percentualPos] : null,
			})
		})
	}

	normalize(): ProductBatchItemFromFileUpdateStockPercentualModel[] {
		return this.itemList
	}

	hasSkuCodeColumn(): boolean {
		return !!this.skuCode
	}

	hasCodeSourceColumn(): boolean {
		return !!this.codeSource
	}

	hasPercentualColumn(): boolean {
		return !!this.percentual
	}

	isValid(): boolean {
		return !!this.itemList.length &&
			(!!this.skuCode || !!this.codeSource) &&
			!!this.percentual;
	}
}
